/* 
  TODO: if the right semantic names are available we put them in the tokens file.
  It is also an attempt (test) to give tokens semantic names for feature benefits
*/

:root {
  /* Semantic names */
  --color-active: var(--color-forest-700);
  --color-background-active: var(--color-forest-100);
  --color-background-active-hover: var(--color-forest-200);
  --color-background-draft: var(--color-navy-100);
  --color-background-draft-hover: var(--color-navy-200);
  --color-background-submitted: var(--color-orange-100);
  --color-background-submitted-hover: var(--color-orange-200);
  --color-border-active: var(--color-forest-700);
  --color-border-draft: var(--color-navy-600);
  --color-border-submitted: var(--color-orange-900);
  --color-draft: var(--color-navy-600);
  --color-draft-hover: var(--color-uva-white);
  --color-label: var(--color-uva-black);
  --color-submitted: var(--color-orange-900);
  --color-submitted-hover: var(--color-uva-white);
  /* Global vars */
  --border-radius-var-indicator: 0.25rem;
}

.var-indicator__container {
  align-items: center;
  appearance: none;
  border: 1px solid;
  border-radius: var(--border-radius-var-indicator);
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: var(--font-size-default);
  font-weight: var(--semibold);
  gap: 0.375rem;
  height: 2rem;
  justify-content: center;
  line-height: inherit;
  margin: 0;
  padding: 0 0.75rem 0 0.5rem;
  white-space: nowrap;
}

.var-indicator__label {
  color: var(--color-label);
}

.var-indicator__step-container {
  align-items: center;
  display: inline-flex;
  height: 100%;
  justify-content: flex-start;
}

.var-indicator__step-container > svg {
  margin: 0 -0.5rem;
}

.var-indicator__container--compact {
  padding: 0;
  position: relative;
  width: 2rem;
}

.var-indicator__container--compact > svg {
  margin: 0;
}

.var-indicator__container--compact-flyover-wrapper {
  display: none;
  height: 2rem;
  position: absolute;
  right: -1px;
  top: -1px;
  width: auto;
  z-index: 1;
}

.var-indicator__container--compact:hover .var-indicator__container--compact-flyover-wrapper {
  display: flex;
}

.var-indicator__container--draft,
.var-indicator__container--rejected,
.var-indicator__container--draft .var-indicator__container--compact-flyover-wrapper,
.var-indicator__container--rejected .var-indicator__container--compact-flyover-wrapper {
  background-color: var(--color-background-draft);
  border-color: var(--color-border-draft);
  color: var(--color-draft);
}

.var-indicator__container--draft:hover,
.var-indicator__container--rejected:hover,
.var-indicator__container--draft:hover .var-indicator__container--compact-flyover-wrapper,
.var-indicator__container--rejected:hover .var-indicator__container--compact-flyover-wrapper {
  background-color: var(--color-background-draft-hover);
}

.var-indicator__container--submitted,
.var-indicator__container--submitted .var-indicator__container--compact-flyover-wrapper {
  background-color: var(--color-background-submitted);
  border-color: var(--color-border-submitted);
  color: var(--color-submitted);
}

.var-indicator__container--submitted:hover,
.var-indicator__container--submitted:hover .var-indicator__container--compact-flyover-wrapper {
  background-color: var(--color-background-submitted-hover);
}

.var-indicator__container--active,
.var-indicator__container--active .var-indicator__container--compact-flyover-wrapper {
  background-color: var(--color-background-active);
  border-color: var(--color-border-active);
  color: var(--color-active);
}

.var-indicator__container--active:hover,
.var-indicator__container--active:hover .var-indicator__container--compact-flyover-wrapper {
  background-color: var(--color-background-active-hover);
}
